import React, { useState } from "react";
import { patientInfo } from "../_constant";

export default function PatientInfoSection({
  setVal,
  triggerFunc,
  isDisabled,
}) {
  const [count, setCount] = useState(0);

  return (
    <div className="w-[20%]">
      <div
        className={`p-2 flex flex-col gap-2 border rounded ${isDisabled ? "opacity-60" : ""} `}
      >
        <div className="text-gray-600 p-2 justify-center flex font-semibold">
          Select Patient Info
        </div>
        {patientInfo.map((ele, idx) => {
          return (
            <div
              key={idx}
              className={`w-full h-12 border px-2 rounded flex justify-between items-center
                ${isDisabled ? "bg-gray-50 cursor-not-allowed" : " cursor-pointer "}`} // Add styles when disabled
              onClick={() => {
                if (!isDisabled) {
                  // Prevent click when disabled
                  setVal(ele.value);
                  triggerFunc(count);
                  setCount(count + 1);
                }
              }}
              aria-disabled={isDisabled}
            >
              {ele.name}
            </div>
          );
        })}
      </div>
    </div>
  );
}
